// Lib
import React from 'react';

// Components
import EmptyPopupMessage from '../../../../../../components/popupPanel/EmptyPopupMessage';

// Note: this is set up as a "URL redirect" within Prismic,
//       redirects to the correct article on help.milanote.com
const BOARD_SHARE_HELP_CENTER_URL = 'http://milanote.com/help-center-board-share';

const NoNotificationsMessage = () => (
    <EmptyPopupMessage
        image={<img src={require('./no-notifications.png')} width="120" height="130" />}
        message="If you share a board, we’ll notify you when someone makes a change"
        secondary={
            <a target="_blank" rel="noopener noreferrer" href={BOARD_SHARE_HELP_CENTER_URL}>
                Find out more about shared boards
            </a>
        }
    />
);

export default NoNotificationsMessage;
